import { FC, useEffect, useState } from "react";
import { useWebgate } from "@xvia/webgate-connect";
import { fetchCatalogByCategory } from "../../apis/relevant-catalog";
import { ServiceMenuSection, ServiceMenu } from "./service-menu";
import { VolunteerActivismOutlined, ChatBubbleOutline, BusinessCenterOutlined } from "@mui/icons-material";
import { ROUTES } from "../../routes";


/* ➜ Slugs e rótulos definidos apenas aqui */
const CARD_DEFS = [
    { slug: "saude", title: "Saúde", Icon: VolunteerActivismOutlined },
    { slug: "direitos-e-cidadania", title: "Cidadania", Icon: ChatBubbleOutline },
    { slug: "documentos-e-certidoes", title: "Documentos e Certidões", Icon: BusinessCenterOutlined },
] as const;

export const ServiceMenuContainer: FC = () => {
    const { accessToken } = useWebgate();
    const [sections, setSections] = useState<(ServiceMenuSection & { icon: typeof VolunteerActivismOutlined })[]>();

    useEffect(() => {
        (async () => {
            try {
                const data = await Promise.all(
                    CARD_DEFS.map(async ({ slug, title, Icon }) => {
                        const res = await fetchCatalogByCategory(slug, accessToken);
                        return {
                            title,
                            linkLabel: "Todos",
                            linkUrl: `${ROUTES.SERVICE_LIST_PAGE}?category=${slug}`,
                            icon: Icon,
                            items: res.map((c) => ({
                                slug: c.slug,
                                type: c.isOnline ? "Online" : "Presencial",
                                name: c.title,
                            })),
                        } as ServiceMenuSection & { icon: typeof VolunteerActivismOutlined };
                    })
                );
                setSections(data);
            } catch (err) {
                console.error("Erro ao buscar serviços destacados:", err);
            }
        })();
    }, [accessToken]);

    if (!sections?.length) return null;

    return (
        <ServiceMenu
            heading="Serviços Disponíveis"
            subheading="Selecione um serviço para obter mais informações"
            buttonLabel="Acessar todos"
            sections={sections}
        />
    );
};